import { create } from 'zustand';
import { Cart } from '../types';
import { cartApi } from '../api';

interface CartState {
  cart: Cart | null;
  loading: boolean;
  fetchCart: () => Promise<void>;
  addItem: (productId: number, quantity: number, variantId?: number | null) => Promise<void>;
  updateItem: (productId: number, quantity: number, variantId?: number | null) => Promise<void>;
  removeItem: (productId: number, variantId?: number | null) => Promise<void>;
  addGroupBuyItem: (groupBuyId: number, quantity: number, variantId?: number | null) => Promise<void>;
  updateGroupBuyItem: (groupBuyId: number, quantity: number, variantId?: number | null) => Promise<void>;
  removeGroupBuyItem: (groupBuyId: number, variantId?: number | null) => Promise<void>;
}

export const useCartStore = create<CartState>((set) => ({
  cart: null,
  loading: false,

  fetchCart: async () => {
    try {
      const res = await cartApi.get();
      set({ cart: res.data.data });
    } catch {}
  },

  addItem: async (productId, quantity, variantId) => {
    await cartApi.addItem(productId, quantity, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },

  updateItem: async (productId, quantity, variantId) => {
    await cartApi.updateItem(productId, quantity, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },

  removeItem: async (productId, variantId) => {
    await cartApi.removeItem(productId, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },

  addGroupBuyItem: async (groupBuyId, quantity, variantId) => {
    await cartApi.addGroupBuy(groupBuyId, quantity, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },

  updateGroupBuyItem: async (groupBuyId, quantity, variantId) => {
    await cartApi.updateGroupBuy(groupBuyId, quantity, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },

  removeGroupBuyItem: async (groupBuyId, variantId) => {
    await cartApi.removeGroupBuy(groupBuyId, variantId);
    const res = await cartApi.get();
    set({ cart: res.data.data });
  },
}));
